export default __webpack_public_path__ + "static/media/mail.5b727253.svg";